import { useState, useEffect } from 'react';

export default function MobileInfoBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('mobile-info-banner-dismissed');
    if (!dismissed) {
      const timer = setTimeout(() => {
        setIsVisible(true);
        const mq = window.matchMedia('(max-width: 767px)');
        if (mq.matches) {
          document.body.style.paddingBottom = '64px';
        }
      }, 600);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  useEffect(() => {
    return () => {
      document.body.style.paddingBottom = '';
    };
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    localStorage.setItem('mobile-info-banner-dismissed', 'true');
    document.body.style.paddingBottom = '';
    setTimeout(() => setIsVisible(false), 300);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 md:hidden transition-transform duration-300 ease-out ${
        isClosing ? 'translate-y-full' : 'translate-y-0'
      }`}
    >
      {/* Close button — sits slightly above the bar */}
      <div className="flex justify-end px-4">
        <button
          onClick={handleClose}
          className="w-7 h-7 bg-background-50 border border-primary-900/15 rounded-full flex items-center justify-center shadow-sm hover:bg-background-100 transition-colors cursor-pointer -mb-1 relative z-10"
          aria-label="Close banner"
        >
          <i className="ri-close-line text-primary-900 text-sm"></i>
        </button>
      </div>

      {/* Main banner strip */}
      <div className="bg-background-50 border-t border-primary-900/10 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]">
        <div className="flex items-center justify-center gap-6 px-4 py-3">
          {/* Phone */}
          <a
            href="tel:+19057099985"
            className="flex items-center gap-2.5 cursor-pointer group"
            aria-label="Call pharmacy at (905) 709-9985"
          >
            <div className="w-9 h-9 rounded-full bg-accent-600/10 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-600/20 transition-colors">
              <i className="ri-phone-line text-accent-600 text-base"></i>
            </div>
            <div className="leading-tight">
              <span className="block text-[10px] text-foreground-400 uppercase tracking-wide font-medium">
                Phone
              </span>
              <span className="block text-sm font-bold text-primary-900 whitespace-nowrap">
                (905) 709-9985
              </span>
            </div>
          </a>

          {/* Divider */}
          <div className="w-px h-8 bg-primary-900/10 flex-shrink-0"></div>

          {/* Fax */}
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-full bg-primary-900/5 flex items-center justify-center flex-shrink-0">
              <i className="ri-printer-line text-primary-900/60 text-base"></i>
            </div>
            <div className="leading-tight">
              <span className="block text-[10px] text-foreground-400 uppercase tracking-wide font-medium">
                Fax
              </span>
              <span className="block text-sm font-bold text-primary-900 whitespace-nowrap">
                (905) 709-9986
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}